import React, { Component } from 'react';
import { 
  Row, 
  Col, 
  Form, 
} from 'react-bootstrap';

class JoiningDate extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      displayJoiningDate: '',
      error: ''
    };
  }

  componentDidMount = async() => {
    const currRole = this.props.profile.getDefaultProfile().joiningDate;
    this.setState({
      displayJoiningDate: currRole || ''
    });
  }

  onBlur = event => {
    event.preventDefault();
    const { displayJoiningDate } = this.state;
    this.props.profile.getDefaultProfile().joiningDate = displayJoiningDate;
    this.props.profile.save();
  };

  onChange = event => {
   
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    return (
      <Form.Group>
        <Row className="text-left">
          <Col>
            <Form.Label>Date of Joining</Form.Label> 
            <Form.Control
              name="displayJoiningDate"
              value={this.state.displayJoiningDate}
              onBlur={this.onBlur}
              onChange={this.onChange}
              type="date"
              max={new Date().toISOString().split("T")[0]}
              
            />
        
     
          </Col>
        </Row>
      </Form.Group>
    );
  }
}

export default JoiningDate;
